import React, { Component } from 'react';
import DatePicker from "react-datepicker";
import { DateInput } from 'semantic-ui-calendar-react';
import { dateToStr, format } from '../../utilities/date'

class SearchElement extends Component {

    constructor(props) {
        super(props);
     
        this.state = {
          date: '',
          time: '',
          dateTime: '',
          datesRange: ''
        };
      }
     
      handleChange = (event, {name, value}) => {
        if (this.state.hasOwnProperty(name)) {
          this.setState({ [name]: value });
        }

        this.props.updateFinalSearchCriteria(this.props.currentRowIndex, this.props.currentOption, value);
      }

      handleInputChange = (e) =>
      {
        this.props.updateFinalSearchCriteria(this.props.currentRowIndex, this.props.currentOption, e.target.value);
      }
    render() {
        return (
            <div>
                {this.props.currentOption && this.props.currentOption.key != "None"? 
                this.props.currentOption.ftype == "date" ?
                   <DateInput
                   popupPosition='bottom right'
                   label={''}
                   dateFormat={format}
                   name='date'
                   value={this.props.currentOption.givenValue}
                   iconPosition='left'
                   preserveViewMode={true}
                   autoComplete='off'
                   closable= {true}
                   onChange={this.handleChange}
                   pickerStyle="{{width:180px}}"
                  /> :
              (<div class="ui input">
                <input type="text" style={{width: "204px"}} onChange={this.handleInputChange} value={this.props.currentOption.givenValue}>
                </input>
              </div>) :
              (<div class="ui input">
                  <input type="text" style={{width: "204px"}}  disabled={true} value="">
                  </input>
                </div>)
            }
            </div>
        );
    }
}

export default SearchElement;


// WEBPACK FOOTER //
// ./components/home/SearchElement.js